var anglicize = require("./lib/anglicize");

module.exports = anglicize;



/*****************
 ** WEBPACK FOOTER
 ** ./~/anglicize/index.js
 ** module id = 570
 ** module chunks = 0
 **/